<div style="background-color: #00a8ff" data-cy="insurance-dx-cross-ref-header">
<h3 data-cy="insurance-dx-cross-ref-title">DentalXchange Cross Reference</h3>
<p data-cy="insurance-dx-cross-ref-subtitle">Relationships</p>
</div>

<div style="display: flex; flex-direction: row" data-cy="insurance-dx-cross-ref-container">
  <div style="flex: 1;" data-cy="insurance-dx-cross-ref-my-section">
    <span data-cy="insurance-dx-cross-ref-my-label">My Insurance Relationships: &nbsp;&nbsp;&nbsp;&nbsp;  Maps To --></span>
    <dx-list
      [height]="listHeight"
      [dataSource]="claimParatmeters"
      [selectionMode]="'single'"
      [selectedItemKeys]="[]"
      [keyExpr]="data.ParameterNameOrID"
      (onSelectionChanged)="myRelationshipSelectionChanged($event)"
      data-cy="insurance-dx-cross-ref-my-list"
    >

      <div *dxTemplate="let item of 'item'" data-cy="insurance-dx-cross-ref-my-item">

        <div style="display: flex; flex-direction: row;" data-cy="insurance-dx-cross-ref-my-item-row">

          <div style="flex-basis: 80%;" data-cy="insurance-dx-cross-ref-my-item-description">{{ item.Description }}</div>
          <div style="flex-basis: 10%;" data-cy="insurance-dx-cross-ref-my-item-value">{{ item.Value1 }}</div>

        </div>

      </div>


    </dx-list>
  </div>
  <div style="flex: 1;" data-cy="insurance-dx-cross-ref-dx-section">
    <span data-cy="insurance-dx-cross-ref-dx-label">DentalXchange Values</span>
    <dx-list
      [height]="listHeight"
      [dataSource]="relationEnumsPerDX"
      [selectionMode]="'single'"
      selectedItemKeys="selectedDXItemKeys"
      keyExpr="IDvalue"
      [showSelectionControls]="true"
      (onSelectionChanged)="DXRelationshipSelectionChanged($event)"
      data-cy="insurance-dx-cross-ref-dx-list"
    >

      <div *dxTemplate="let item of 'item'" data-cy="insurance-dx-cross-ref-dx-item">
        <div style="display: flex; flex-direction: row;" data-cy="insurance-dx-cross-ref-dx-item-row">
          <div style="flex-basis: 10%;" data-cy="insurance-dx-cross-ref-dx-item-id">{{ item.IDvalue }}</div>
          <div style="flex-basis: 80%;" data-cy="insurance-dx-cross-ref-dx-item-description">{{ item.description }}</div>
<!--          <div style="flex-basis: 10%;"> <input type="radio" [(ngModel)]="item.selected" />  </div>-->

        </div>
      </div>


    </dx-list>





  </div>

</div>
<div style="display: flex; flex-direction: row; justify-content: flex-end;" data-cy="insurance-dx-cross-ref-actions">
  <dx-button style="width: 50px; margin-right: 10px;" (onClick)="onSave()" data-cy="insurance-dx-cross-ref-save-button">Save</dx-button>
  <dx-button style="width: 50px; margin-right: 10px;" (onClick)="onCancel()" data-cy="insurance-dx-cross-ref-cancel-button">Cancel</dx-button>
</div>


